import { TokenStorage } from './token-storage';
import { alert } from './message-box';
import { confirmAdminDemoMode } from '../pages/SchedulePage/course-dialog/ConfirmMessageBoxes';
import router from '../router';

const tokenStorage = new TokenStorage();

async function handleDemoAccountModifyingError() {
  const confirmAnswer = await confirmAdminDemoMode();

  if (confirmAnswer) {
    window.open(
      'https://admin.fiflbox.com/#/register?utm_source=demo_website&utm_medium=error_button',
      '_blank'
    );
  }

  throw new Error('Demo account cannot modify data');
}

function handleDefaultError(message) {
  throw Error(message);
}

function handleExpiredAccountError(message) {
  tokenStorage.deleteToken();
  return router.replace('/expired').catch(() => {});
}

function handleDataTransferAccountError(message) {
  tokenStorage.deleteToken();
  return router.replace('/announce/data-transfer').catch(() => {});
}

export function handleUnauthorizedAccountError(message) {
  tokenStorage.deleteToken();
  return router.replace('/').catch(() => {});
}

export async function emojiDetectedError(message) {
  const title = '이모지 입력 불가';
  const content = message;
  await alert(content, title);
  return Promise.reject(message);
}

export const AUTH_ERROR = {
  300: {
    message:
      '입력하신 이모지는 사용할 수 없습니다. 이모지를 제외하고 저장해 주시길 바랍니다.',
    handler: emojiDetectedError
  },
  401: {
    message: '데이터를 불러오는데 실패했습니다.',
    handler: handleUnauthorizedAccountError
  },
  700: {
    message: '데이터를 불러오는데 실패했습니다.',
    handler: handleUnauthorizedAccountError
  },
  701: {
    message: '이메일 계정 또는 비밀번호를 다시 한번 확인해주세요.',
    handler: handleDefaultError
  },
  702: {
    message: '계정이 중지되었거나 삭제되었습니다.',
    handler: handleDefaultError
  },
  703: {
    message: '센터 회원 계정이 만료되었습니다.',
    handler: handleExpiredAccountError
  },
  704: {
    message: '소속된 센터가 없습니다.',
    handler: handleDefaultError
  },
  705: {
    message: '관리자 체험 모드에서는 조회만 가능합니다.',
    handler: handleDemoAccountModifyingError
  },
  706: {
    message: '무료 플랜 제한 인원을 초과하셨습니다.',
    handler: handleExpiredAccountError
  },
  708: {
    message: '데이터 이전상태 입니다.',
    handler: handleDataTransferAccountError
  }
};
